module.exports = __webpack_public_path__ + "static/img/1.defe014.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/1.png
// module id = V54+
// module chunks = 0